<script setup>
definePage({
  name: 'shipment-warehouse-pl-files-index',
  meta: {
    requiresAuth: true,
    action: 'read',
    subject: 'Parcels',
  },
})

// Sidebar entry: pick a container, then open its Fichiers PL page (FINAL 7 / PRODUCT LIST…).
import ContainerPicker from '@/components/shipment/ContainerPicker.vue'
</script>

<template>
  <ContainerPicker
    title="Fichiers PL"
    base-path="/shipment/warehouse/pl-files"
    icon="tabler-file-spreadsheet"
  />
</template>
